import styled from 'styled-components'

export const BoardHolder = styled.div`
  background: ${({ theme }) => theme.webMktPalette.background.gray};
  display: grid;
  grid-template-columns: repeat(4, auto);
  justify-content: space-between;

  ${props => props.theme.breakpoints.down('sm')} {
    grid-template-columns: repeat(2, auto);
    justify-content: space-around;
    grid-column-gap: 16px;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    grid-template-columns: repeat(1, auto);
  }
`
